import {
  SIGNIN,
  AUTHENTICATED,
  AUTHENTICATED_FAILED,
  SIGNOUT,
  SIGNOUT_SUCCESS,
  SHOW_AUTH_MESSAGE,
  HIDE_AUTH_MESSAGE,
  SIGNUP,
  SIGNUP_SUCCESS,
  SHOW_LOADING,
  HIDE_LOADING,
  REFRESH_TOKEN,
  REFRESH_TOKEN_FAILURE,
  REFRESH_TOKEN_SUCCESS,
  REFRESH_TOKEN_DISPATCHED,
} from "../constants/Auth";

export const signIn = (user) => {
  return {
    type: SIGNIN,
    payload: user,
  };
};

export const refreshTokenAction = (token) => {
  return {
    type: REFRESH_TOKEN,
    payload: token,
  };
};

export const refreshTokenSuccessAction = (data) => ({
  type: REFRESH_TOKEN_SUCCESS,
  payload: data
});

export const refreshTokenFailureAction = (error) => ({
  type: REFRESH_TOKEN_FAILURE,
  payload: error,
});

export const refreshTokenDispatched = () => ({
  type: REFRESH_TOKEN_DISPATCHED,
});

export const authenticated = (accessToken, refreshToken, roles, permissions, refreshTokenDispatched) => {
  return {
    type: AUTHENTICATED,
    accessToken,
    refreshToken,
    roles,
    permissions,
    refreshTokenDispatched
  };
};

export const authenticatedFailed = () => {
  return {
    type: AUTHENTICATED_FAILED,
  };
};

export const signOut = () => {
  return {
    type: SIGNOUT,
  };
};

export const signOutSuccess = () => {
  return {
    type: SIGNOUT_SUCCESS,
  };
};

export const signUp = (user) => {
  return {
    type: SIGNUP,
    payload: user,
  };
};

export const signUpSuccess = (token) => {
  return {
    type: SIGNUP_SUCCESS,
    token,
  };
};

export const showAuthMessage = (message) => {
  return {
    type: SHOW_AUTH_MESSAGE,
    message,
  };
};

export const hideAuthMessage = () => {
  return {
    type: HIDE_AUTH_MESSAGE,
  };
};

export const showLoading = () => {
  return {
    type: SHOW_LOADING,
  };
};

export const hideLoading = () => {
  return {
    type: HIDE_LOADING,
  };
};
